import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewQualityControlType = ({ qcType }) => {
  if (!qcType) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Quality Control Type Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            QC Type: {qcType.qcType}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Description: {qcType.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Formula ID: {qcType.formulaId}
          </Typography>
        </Grid>
        {/* Add more fields as needed */}
      </Grid>
    </Paper>
  );
};

export default ViewQualityControlType;
